import Query from '../../../Query.js';

const getVerificationTokenForSuperAdminByEmail = async function( email ) {
	const { data, errors } = await this.request(
		new Query( {
			type: 'query',
			name: 'getVerificationTokenByEmail',
			params: {
				where: {
					user: {
						email,
					},
				},
			},
			returnFields: [ 'id' ],
		} )
	);

	if ( errors ) {
		return { errors };
	}

	return data;
};

const getPasswordResetTokenByEmail = async function( email ) {
	const { data, errors } = await this.request(
		new Query( {
			type: 'query',
			name: 'getPasswordResetTokenByEmail',
			params: {
				where: {
					email,
				},
			},
			returnFields: [ 'passwordResetToken' ],
		} )
	);
	if ( errors ) {
		return { errors };
	}
	return data.data.getPasswordResetTokenByEmail;
};

export {
	getVerificationTokenForSuperAdminByEmail,
	getPasswordResetTokenByEmail,
};
